import React from 'react'
import Navbar from '../inc/Navbar'
import { Link } from 'react-router-dom'
import Toshiba from './Toshiba'


function Toshibapage() {
  return (
    <div>
              <Navbar />
      <br />
      <br />
      <br />
      <br />
      <div className='ackrishnagar'>
        <div className="album py-1">
          <div className="container mt-2">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Toshiba</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
<Toshiba/>

    </div>
  )
}

export default Toshibapage